import React, {useState} from 'react';
import {
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Container,
  Grid,
  MenuItem,
  Typography,
  Divider,
  Box
} from '@mui/material';
import FeedbackCardcomponent from './FeedbackCardcomponent';
import CustomPopover, {usePopover} from 'src/components/custom-popover';
import FeedbackOpen from './FeedbackQuestioner/FeedbackOpen';
import {useBoolean} from 'src/hooks/use-boolean';
import PreviewComponentFeedback from './FeedbackQuestioner/PreviewComponentFeedback';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface TemplateOption {
  label: string;
  clickable: boolean;
}
const overviewData = `
<h4>Share your feedback and tell us about your experience with this course.
</h4>
`;
const thankyouData = `

<h3>Thank you for your feedback!
</h3>
`;
const questionObject = [
  {
    disableComments: true,
    makecommentmandatory: true,
    markasMandatory: true,
    choices: [
      {id: 1, value: '1'},
      {id: 2, value: '2'}
    ],
    id: 1,
    question: 'data',
    questionType: 'single'
  }
];
interface feedbackpopoverprops {
  id: number;
  label: string;
}
interface FeedbackFormCreationProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formquestionsData: any[];
  feedbackname: string;
  introductiondata: string;
  thanksdata: string;
  id: number;
}
const FeedbackFormCreation: React.FC = () => {
  const [questions, setQuestionsdata] = useState<FeedbackFormCreationProps[]>(
    []
  );
  const [questionids, setQuestionids] = useState<number>(1);
  const [selectedDetails, setSelectedDetails] = useState<{
    value: string;
    questions: string;
    id: string;
  }>({
    value: 'Feedback',
    questions: '1',
    id: '0'
  });
  const [editfeedbackid, setEditfeedbackid] = useState<number | null>(null);
  // State to store the data
  const [editmode, setEditmode] = useState(false);
  const [previewmode, setPreviewmode] = useState(false);
  const [previewfeedbackid, setPreviewfeedbackid] = useState<number | null>(
    null
  );
  const [selectedValue, setSelectedValue] = useState(0);
  const [editQuestions, setEditQuestions] = useState<
    FeedbackFormCreationProps[]
  >([]);
  const [data, setData] = useState<feedbackpopoverprops[]>([]);
  React.useEffect(() => {
    if (questions.length > 0) {
      setSelectedDetails({
        value: questions[0].feedbackname,
        questions: questions[0].formquestionsData.length.toString(), // Convert number to string
        id: questions[0].id.toString() // Convert number to string
      });
    }
  }, [editmode, questions]);
  const createNew = useBoolean();
  const popover = usePopover();
  const handleCloseDialog = (formData: any) => {
    if (editmode) {
      setEditmode(false);
      //update the setData and questionsdata
      const updateData = data.map(item => {
        if (item.id === formData.id) {
          return {id: formData.id, label: formData.feedbackname};
        }
        return item;
      });
      setData(updateData);
      const updateQuestions = questions.map(item => {
        if (item.id === formData.id) {
          return formData;
        }
        return item;
      });
      setQuestionsdata(updateQuestions);
      createNew.onFalse();
    } else {
      setQuestionids(questionids + 1);
      setData([...data, {id: formData.id, label: formData.feedbackname}]);
      setQuestionsdata([...questions, formData]);
      createNew.onFalse();
    }
  };

  return (
    <>
      <Container
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: '100% !important',
          py: '3vh'
        }}>
        <Grid
          container
          spacing={2}
          sx={{margin: '0 !important', width: '100% !important'}}>
          <h3>Feedback</h3>
        </Grid>
        <FormGroup>
          <Grid item xs={12} sx={{margin: '2vh 0'}}>
            <h4>Select a feedback template</h4>
            <p style={{paddingBottom: '1vh'}}>
              Use the default template or create your template to collect
              feedback on the course
            </p>
            <Grid item xs={12} sx={{display: 'inline-grid'}}>
              <Box sx={{my: '1vh'}}>
                <Button
                  variant="contained"
                  color="info"
                  onClick={popover.onOpen}>
                  + Select Template
                </Button>
                <CustomPopover
                  open={popover.open}
                  onClose={popover.onClose}
                  arrow="top-right"
                  sx={{width: 160}}>
                  <MenuItem
                    color={popover.open ? 'inherit' : 'default'}
                    onClick={() => {
                      popover.onClose();
                      createNew.onTrue();
                    }}>
                    + Create New
                  </MenuItem>
                  <Divider sx={{borderStyle: 'dashed'}} />
                  <MenuItem
                    color={popover.open ? 'inherit' : 'default'}
                    onClick={() => {
                      popover.onClose();
                    }}>
                    Default
                  </MenuItem>
                  <Divider sx={{borderStyle: 'dashed'}} />
                  <Typography
                    color="textSecondary"
                    display="flex"
                    justifyContent="center"
                    py="5px"
                    fontSize=" 10px !important">
                    EXISTING TEMPLATES
                  </Typography>
                  <MenuItem
                    color={popover.open ? 'inherit' : 'default'}
                    onClick={() => {
                      popover.onClose();
                    }}>
                    Testing Feedback
                  </MenuItem>{' '}
                  {data.map(item => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                      onClick={() => {
                        setSelectedValue(item.id);
                        const valueupdate = questions.find(
                          itemdata => itemdata.id === item.id
                        );
                        setSelectedDetails(
                          valueupdate &&
                            valueupdate?.formquestionsData.length > 0 &&
                            valueupdate?.feedbackname !== undefined
                            ? {
                                value: valueupdate.feedbackname,
                                questions:
                                  valueupdate.formquestionsData.length.toString(), // Convert number to string
                                id: valueupdate.id.toString() // Convert number to string
                              }
                            : {value: '', questions: '', id: ''}
                        );
                        popover.onClose();
                      }}>
                      {item.label}
                    </MenuItem>
                  ))}
                  <MenuItem
                    color={popover.open ? 'inherit' : 'default'}
                    onClick={() => {
                      popover.onClose();
                    }}>
                    Template A
                  </MenuItem>
                </CustomPopover>
              </Box>
              <FeedbackCardcomponent
                title={selectedDetails.value}
                total={`Question:${selectedDetails.questions}`}
                value={selectedDetails.id}
                onEdit={(value: string) => {
                  setEditmode(true);
                  const valueupdate = questions.find(
                    itemdata => itemdata.id === parseInt(value)
                  );
                  setEditQuestions(valueupdate ? [valueupdate] : []);
                  setEditfeedbackid(parseInt(value));
                }}
                onPreview={(value: string) => {
                  setPreviewmode(true);
                  setPreviewfeedbackid(parseInt(value));
                }}
                onDelete={(value: string) => {
                  const updatedData = data.filter(
                    item => item.id !== parseInt(value)
                  );
                  setData(updatedData);
                  const updatedQuestions = questions.filter(
                    item => item.id !== parseInt(value)
                  );
                  setQuestionsdata(updatedQuestions);
                }}
              />
              <FormControlLabel
                sx={{marginTop: '1vh', maxWidth: 'max-content'}}
                control={<Switch />}
                label="Mandatory"
              />
            </Grid>
          </Grid>
        </FormGroup>
        <Button variant="contained" color="primary" style={{marginTop: '20px'}}>
          Save
        </Button>
      </Container>
      {createNew.value && (
        <Container
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '100% !important',
            py: '3vh',
            marginTop: '2vh'
          }}>
          <FeedbackOpen
            onSaveClose={handleCloseDialog}
            feedbacksavedQuestions={{
              formquestionsData: questionObject,
              feedbackname: 'Feedback',
              introductiondata: overviewData,
              thanksdata: thankyouData,
              id: 1
            }}
            questionfeedbackid={questionids}
          />
        </Container>
      )}
      {editmode && editfeedbackid && (
        <Container
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            maxWidth: '100% !important',
            py: '3vh',
            marginTop: '2vh'
          }}>
          <FeedbackOpen
            onSaveClose={handleCloseDialog}
            feedbacksavedQuestions={editQuestions[0]}
            questionfeedbackid={questionids}
            editmodefeedback={editmode}
          />
        </Container>
      )}
      {previewmode && previewfeedbackid && (
        <PreviewComponentFeedback
          open={previewmode}
          PreviewQuestionData={questions.find(
            item => item.id === previewfeedbackid
          )}
          onClose={() => setPreviewmode(false)}
        />
      )}
    </>
  );
};

export default FeedbackFormCreation;
